import * as React from "react";
import i18n from "i18n";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles,
  FormControl,
  Snackbar,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import { observer } from "mobx-react";
import CreateSelect from "common/components/CreatableSelect";
import { ProfileService } from "modules/profile/ProfileService";
import { LoginService } from "modules/login/LoginService";

const styles = (theme) => ({
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
  },
  chip: {
    margin: "0px 5px",
  },
});

type IProps = {
  classes: any;
};

const createOption = (label: string, uid: string) => ({
  label,
  value: label,
  uid,
});

@observer
class ShareRateLibrary extends React.Component<IProps> {
  state: any = {
    open: false,
    emails: Array(),
    inputValue: "",
    value: [],
    message: "",
  };

  handleChange = (value: any) => {
    this.setState({ value });
  };

  handleInputChange = (inputValue, action: any) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      this.setState({ inputValue });
    }
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  handleOpenShareSnack = (msg) => {
    this.setState({ open: true, inputValue: "", message: msg });
  };

  handleBlur(event) {
    if (this.state.inputValue) {
      this.handleChange({
        value: this.state.inputValue,
        label: this.state.inputValue,
      });
    }
  }

  handleKeyDown = async (event) => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;
    switch (event.which) {
      case 13:
      case 32:
      case 9:
        event.preventDefault();
        event.stopPropagation();
        let emailUser = await LoginService.FetchUserByEmail(inputValue, false);
        let uid = ProfileService.getUserId();

        if (
          emailUser &&
          emailUser.uid !== uid &&
          !value.find((v) => v.value === emailUser.email)
        ) {
          this.setState({
            inputValue: "",
            value: [...value, createOption(inputValue, emailUser.uid)],
          });
        }

        if (!emailUser || emailUser === null) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailNotFound);
        } else if (emailUser.uid === uid) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailsOwner);
        } else if (value.find((v) => v.value === emailUser.email)) {
          this.handleOpenShareSnack(i18n.rateLibraries.error.emailAlreadyAdded);
        }
    }
  };

  handleUpdateonClick = async () => {
    const { inputValue, value } = this.state;
    if (!inputValue) return;
    let emailUser = await LoginService.FetchUserByEmail(inputValue, false);
    let uid = ProfileService.getUserId();
    if (
      emailUser &&
      emailUser.uid != uid &&
      !value.find((v) => v.value === emailUser.email)
    ) {
      this.setState({
        inputValue: "",
        value: [...value, createOption(inputValue, emailUser.uid)],
      });
    }

    if (!emailUser || emailUser === null) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailNotFound);
      return false;
    } else if (emailUser.uid === uid) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailsOwner);
      return false;
    } else if (value.find((v) => v.value === emailUser.email)) {
      this.handleOpenShareSnack(i18n.rateLibraries.error.emailAlreadyAdded);
      return false;
    }
    return true;
  };

  handleUpdate = async () => {
    let saveItens: any = this.state.value.map((id) => id.uid);
    RateLibraryStore.saveUsers(saveItens);
    this.setState({ value: [] });
    RateLibraryStore.openShareLibraryDialog = false;
  };

  handleEnter = async () => {
    if (RateLibraryStore.openShareLibrary.data.sharedUsers) {
      let mapUsers = RateLibraryStore.openShareLibrary.data.sharedUsers.map(
        (user) => {
          return createOption(user.email, user.uid);
        }
      );
      this.setState({ value: mapUsers });
    }
  };

  handleClose = () => {
    this.setState({ value: [] });
    RateLibraryStore.openShareLibraryDialog = false;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          open={RateLibraryStore.openShareLibraryDialog}
          onClose={this.handleClose}
          onEnter={this.handleEnter}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {i18n.rateLibraries.shareLibraries}
          </DialogTitle>
          <DialogContent style={{ width: 600 }}>
            <FormControl className={classes.input}>
              <CreateSelect
                inputValue={this.state.inputValue}
                handleChange={this.handleChange}
                isSearchable
                handleInputChange={this.handleInputChange.bind(this)}
                handleKeyDown={this.handleKeyDown}
                onChange={this.handleChange}
                onInputChange={this.handleInputChange}
                onKeyDown={this.handleKeyDown}
                value={this.state.value}
                placeholder={i18n.rateLibraries.layerAdd.sharePlaceholder}
                isMulti
                isClearable
                onBlur={this.handleBlur.bind(this)}
              ></CreateSelect>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              {i18n.cancel}
            </Button>
            <Button
              onClick={async () => {
                if (this.state.inputValue != "") {
                  let isMessage = await this.handleUpdateonClick();
                  if (isMessage == false) return;
                }
                this.handleUpdate();
              }}
              color="primary"
            >
              {i18n.share}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.open}
          message={<span id="message-id">{this.state.message}</span>}
          onClose={this.handleCloseSnack}
          autoHideDuration={4000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={this.handleCloseSnack}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ShareRateLibrary);



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/ShareRateLibrary.tsx